import React, { useState } from "react";
import { NavLink } from "react-router-dom";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  eyebrow?: string;
  title?: string;
  faqs?: FaqItem[];
  ctaLabel?: string;
  ctaHref?: string;
}

const defaultFaqs: FaqItem[] = [
  {
    question: "Pourquoi une consultation avant la Hijama ?",
    answer:
      "La consultation permet d'évaluer votre état de santé général, d'identifier d'éventuelles contre-indications et d'adapter la séance à vos besoins spécifiques, en toute sécurité.",
  },
  {
    question: "Puis-je arrêter mon traitement médical ?",
    answer:
      "Non, aucune prestation ne doit remplacer un traitement médical prescrit. Nos accompagnements sont complémentaires et ne se substituent jamais à un avis médical.",
  },
  {
    question: "Naturel signifie-t-il sans risque ?",
    answer:
      "Non. Un produit ou une pratique naturelle peut présenter des contre-indications ou des interactions. C'est pourquoi chaque prestation est encadrée avec sérieux et explication préalable.",
  },
  {
    question: "Comment prendre rendez-vous ?",
    answer:
      "Vous pouvez prendre rendez-vous via le bouton « Prendre rendez-vous », qui ouvre WhatsApp. Nous reviendrons vers vous rapidement pour convenir d'un créneau adapté.",
  },
];

const FaqSection: React.FC<FaqSectionProps> = ({
  eyebrow = "FAQ",
  title = "Vos questions fréquentes",
  faqs = defaultFaqs,
  ctaLabel = "Consulter toutes les questions",
  ctaHref = "/faq",
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleIndex = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="faq-section py-5 py-lg-6">
      <div className="container-xl">
        <div className="text-center mb-5">
          <p className="faq-eyebrow mb-3">{eyebrow}</p>
          <h2 className="faq-title">{title}</h2>
        </div>

        <div className="faq-list mx-auto">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className="faq-item mb-3">
                <button
                  type="button"
                  className="faq-question w-100 d-flex justify-content-between align-items-center"
                  onClick={() => toggleIndex(index)}
                  aria-expanded={isOpen}
                >
                  <span>{faq.question}</span>
                  <span className={`faq-icon ${isOpen ? "faq-icon-open" : ""}`}>
                    +
                  </span>
                </button>

                <div className={`faq-answer ${isOpen ? "faq-answer-open" : ""}`}>
                  <div className="faq-answer-inner">
                    <p className="mb-0">{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-4">
          <NavLink to={ctaHref} className="faq-cta">
            {ctaLabel}
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;